// extracted by mini-css-extract-plugin
export default {"not_found__area":"style_not_found__area__uLRLb","not_found__content":"style_not_found__content__iw+P2"};